import React, { forwardRef } from 'react';
const Label = forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(({
  className,
  ...props
}, ref) => <label ref={ref} className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${className}`} {...props} data-id="element-110" />);
Label.displayName = 'Label';
export { Label };